var _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3505ac501f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 152 34 L 314 34 L 314 352.3125 L 152 352.3125 Z M 152 34 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#49ba86",
    d: "M 185.722656 151.890625 C 214.019531 151.890625 236.957031 128.953125 236.957031 100.65625 C 236.957031 72.363281 214.019531 49.421875 185.722656 49.421875 C 157.433594 49.421875 134.496094 72.363281 134.496094 100.65625 C 134.496094 128.953125 157.433594 151.890625 185.722656 151.890625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#49ba86",
    d: "M 292.425781 34.457031 C 291.910156 33.527344 291.617188 33.042969 291.617188 33.042969 C 294.402344 46.71875 296.195312 59.289062 297.191406 70.90625 C 295.6875 131.195312 246.378906 213.574219 185.722656 213.574219 C 125.074219 213.574219 75.765625 131.195312 74.261719 70.90625 C 75.25 59.289062 77.050781 46.71875 79.835938 33.042969 C 79.835938 33.042969 79.539062 33.527344 79.027344 34.457031 C 70.882812 48.042969 65.246094 63.296875 62.785156 79.601562 C 52.644531 125.429688 52.789062 178.496094 120.679688 260.058594 C 132.3125 274.039062 142.972656 288.210938 152.152344 301.125 C 359.019531 167.9375 292.425781 34.457031 292.425781 34.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3505ac501f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1d7151",
    d: "M 308.664062 79.601562 C 306.207031 63.296875 300.570312 48.042969 292.425781 34.457031 C 292.425781 34.457031 359.019531 167.9375 152.152344 301.125 C 172.605469 329.890625 185.699219 352.382812 185.722656 352.425781 L 185.722656 352.429688 L 185.726562 352.429688 L 185.726562 352.425781 C 185.765625 352.363281 213.21875 305.183594 250.773438 260.058594 C 318.660156 178.496094 318.804688 125.429688 308.664062 79.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.702adc646c775768bf124255e241dc22.svg";
export { ForwardRef as ReactComponent };